import type { PinterestCapabilityProfile } from './types.js';

// Limits from the Pinterest v5 Create Pin reference, recorded in the product
// design: title 100, description 800, alt text 500. Counted in code points --
// Pinterest applies no weighting, unlike X.
export const PINTEREST_CAPABILITY: PinterestCapabilityProfile = {
  version: '2026-08-19',
  platform: 'pinterest',
  title: { max: 100 },
  description: { max: 800 },
  image: {
    maxBytes: 20_971_520,
    mimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
    altTextMax: 500,
  },
};
